import { useMutation } from '@tanstack/react-query'
import { TCustomUseQueryMeta, TUseMutationOptions } from 'core/query/type'
import {
  TGetV1UserClosePopupParams,
  TGetV1UserClosePopupResponse,
  getV1UserClosePopup,
} from 'core/service/yapi/hk-web/Hotcoin/api'

import {
  TPostUserLogoutParams,
  TPostUserLogoutResponse,
  postUserLogout,
  TPostModifySafetyCheckParams,
  TPostModifySafetyCheckResponse,
  postModifySafetyCheck,
} from 'core/service/fixLegacyAPI/hk-web/Hotcoin/api'

// hotcoin优化相关接口
// 登录，首先不传验证码，如果调用失败加验证码继续调用此接口
export const useGetV1UserClosePopupMutation = (
  mutationOptions?: TUseMutationOptions<TGetV1UserClosePopupResponse, TGetV1UserClosePopupParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V1UserClosePopup', 'GET'],
    mutationFn: (params?: TGetV1UserClosePopupParams) => getV1UserClosePopup(params),
  })
}

// 用户退出登录
export const usePostUserLogoutMutation = (
  mutationOptions?: TUseMutationOptions<TPostUserLogoutResponse, TPostUserLogoutParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'UserLogout', 'Post'],
    mutationFn: (params?: TPostUserLogoutParams) => postUserLogout(params, mutationOptions?.meta?.requestOptions),
  })
}

// 三项安全验证
export const usePostModifySafetyCheckMutation = (
  mutationOptions?: TUseMutationOptions<TPostModifySafetyCheckResponse, TPostModifySafetyCheckParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'ModifySafetyCheck', 'Post'],
    mutationFn: (params?: TPostModifySafetyCheckParams) =>
      postModifySafetyCheck(params, mutationOptions?.meta?.requestOptions),
  })
}
